<template lang="pug">
.no-data.color_bg_3
  .content
    .no-data_img
    .no-data_content.color_text_2 暂无待领取福利
</template>
<script>
export default {
  data() {
    return {

    };
  },
};
</script>
<style lang="stylus" scoped>
.no-data
  width 100%
  height calc(100% - 92px)
  border-top-left-radius: 16px
  border-top-right-radius: 16px
  position relative
  top -26px
  .content
    width fit-content
    height fit-content
    position: absolute
    top 0
    left 0
    right 0
    bottom 0
    margin auto
  .no-data_img
    width 96px
    height 86.4px
    background url('../assets/imgs/vip/light/no-welfare.png') 0 0 /100% 100% no-repeat
    display block
    margin 0 auto
  .no-data_content
    width auto
    height 24px
    line-height 24px
    text-align center
    font-size 14px
    margin 0px auto
    white-space nowrap
</style>
